import { normalize } from 'polished'
import { createGlobalStyle, css } from 'styled-components'

import { Reset } from './lib/mixins'
import theme from './lib/theme'

const Style = createGlobalStyle`
  ${normalize()}

  ${({ colorScheme }) => {
    const currentTheme = theme({ colorScheme })

    return css`
      html {
        font-size: ${currentTheme.baseSize};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        line-height: 1.15;
        font-family: ${currentTheme.font.primary};
        color: ${currentTheme.color.global};
        font-weight: 400;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
      }

      body {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        background-color: ${currentTheme.color.body};
      }

      * {
        box-sizing: border-box;
      }

      ::-webkit-scrollbar {
        display: none;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0;
        margin-bottom: 1.5rem;
        font-weight: 400;

        strong {
          font-weight: 600;
        }
      }

      h1 {
        font-size: 4rem;
        line-height: 1.15;
        font-family: ${currentTheme.font.secondary};
      }

      h2 {
        font-size: 3.25rem;
        font-family: ${currentTheme.font.secondary};
      }

      h3 {
        font-size: 2rem;
        margin-bottom: 1.5em;
      }

      h4 {
        font-size: 1.25rem;
      }

      a {
        ${Reset('link')}
        color: var(--color-primary);
      }

      p {
        margin-top: 0;
        margin-bottom: 2rem;
        line-height: 1.35;

        strong {
          font-weight: 600;
        }
      }

      img {
        max-width: 100%;
      }

      #modal {
      }
    `
  }}
`

export default Style
